import ButtonDisclosures from '../../../atoms/button-disclosures';
import CardModule from '../../shared/card-module';
import TableBasic from '../../../atoms/table-basic/index';
import format from '../../../../utils/format';
import useProfileCommonStore from '../../../../stores/profile/use-profile-common-store';
import { className } from '../../../../utils/GlobalCssProxy';
import { useProfileRiskMeasures } from '../../../../hooks/api/index';

const RiskMeasures = () => {
  const { apiConfigBase } = useProfileCommonStore();
  const result = useProfileRiskMeasures(apiConfigBase);
  const riskMeasures = result.isLoaded ? result.data : {};

  return (
    <CardModule
      data-analytics-componenttype="third-width-component"
      data-analytics-id="TW_RiskMeasures"
      data-analytics-section="component"
    >
      <CardModule.Header>
        Risk Measures
        <CardModule.AsOfDate>
          {format.date(riskMeasures.asOfDate)}
        </CardModule.AsOfDate>
      </CardModule.Header>
      <CardModule.Body>
        <TableBasic flush>
          <caption {...className('sr-only') }>
            Risk Measures for {riskMeasures.ticker}
          </caption>
          <tbody>
            <tr>
              <th scope="row" {...className('text-left')}>Alpha (Risk Adjusted)</th>
              <td {...className('text-right', 'font-weight-bold')}>
                {format.number(riskMeasures.alpha)}
              </td>
            </tr>
            <tr>
              <th scope="row" {...className('text-left')}>Beta</th>
              <td {...className('text-right', 'font-weight-bold')}>
                {format.number(riskMeasures.beta)}
              </td>
            </tr>
            <tr>
              <th scope="row" {...className('text-left')}>R-squared</th>
              <td {...className('text-right', 'font-weight-bold')}>
                {format.number(riskMeasures.rSquared)}
              </td>
            </tr>
            <tr>
              <th scope="row" {...className('text-left')}>Sharpe Ratio</th>
              <td {...className('text-right', 'font-weight-bold')}>
                {format.number(riskMeasures.sharpeRatio)}
              </td>
            </tr>
            <tr>
              <th scope="row" {...className('text-left')}>Standard Deviation</th>
              <td {...className('text-right', 'font-weight-bold')}>
                {format.number(riskMeasures.standardDeviation)}
              </td>
            </tr>
          </tbody>
        </TableBasic>
      </CardModule.Body>
      <CardModule.Footer {...className('text-right')}>
        <ButtonDisclosures module={'risk-measures'} />
      </CardModule.Footer>
    </CardModule>
  );
};

export default RiskMeasures;
